export const columns = [
  { field: "vaccination_name", headerName: "Vaccination Name" },
  { field: "vaccination_taken_by", headerName: "Name" },
  { field: "type", headerName: "Type" },
  { field: "date_given", headerName: "Date Given" },
  { field: "next_due_date", headerName: "Date Due" },
  { field: "notes", headerName: "Notes" },
  {
    field: "is_given",
    headerName: "Given",
    render: (value) => (
      <span
        style={{
          display: "inline-block",
          padding: "4px 10px",
          borderRadius: "12px",
          backgroundColor: value
            ? "rgba(76, 175, 80, 0.1)"
            : "rgba(244, 67, 54, 0.1)",
          color: value ? "#4caf50" : "#f44336",
          fontWeight: 600,
          fontSize: "0.875rem",
          textAlign: "center",
          minWidth: "40px",
        }}
      >
        {value ? "Yes" : "No"}
      </span>
    ),
  },
];

export const VaccinationPrintColumns = [
  { field: "vaccination_name", header: "Vaccination Name" },
  { field: "vaccination_taken_by", header: "Name" },
  { field: "type", header: "Type" },
  { field: "date_given", header: "Date Given" },
  { field: "next_due_date", header: "Date Due" },
  { field: "notes", header: "Notes" },
  {
    field: "is_given",
    header: "Given",
    // Convert boolean to Yes/No for printing
    render: (value) => (value ? "Yes" : "No"),
  },
];
